import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import { Tooltip } from '~/components/Tooltip';
import type { CommunityReactionType } from '~/interfaces/community';
import { REACTION_EMOJI, REACTION_TYPES } from '~/interfaces/community';
import {
  preventNativeTouchMenu,
  touchSuppressionClass,
  touchSuppressionStyle,
} from '~/routes/community/_hooks/useLongPressTrigger';

interface ReactionTypeButtonsProps {
  ownReactionTypes: CommunityReactionType[];
  onReact: (reactionType: CommunityReactionType, event: MouseEvent<HTMLButtonElement>) => void;
}

export const ReactionTypeButtons: FC<ReactionTypeButtonsProps> = ({ ownReactionTypes, onReact }) => {
  const { t } = useTranslation();

  return (
    <>
      {REACTION_TYPES.map((reactionType) => {
        const isOwn = ownReactionTypes.includes(reactionType);
        return (
          <Tooltip key={reactionType} content={t(`community.reactions.${reactionType}`)}>
            <button
              type="button"
              onClick={(event) => onReact(reactionType, event)}
              aria-label={t(`community.reactions.${reactionType}`)}
              aria-pressed={isOwn}
              onContextMenu={preventNativeTouchMenu}
              className={cx(
                'flex items-center justify-center size-8 rounded-full text-[15px] leading-none transition-all hover:scale-125 hover:bg-black/5',
                touchSuppressionClass,
                { 'bg-black/10': isOwn },
              )}
              style={touchSuppressionStyle}
            >
              {REACTION_EMOJI[reactionType]}
            </button>
          </Tooltip>
        );
      })}
    </>
  );
};
